import React from "react"
import { StaticQuery, graphql, Link } from "gatsby"
import { getTotal } from "../helpers/categories"

const InsightFilters = (props) => (
  <StaticQuery
    query={graphql`
      {
        allSanityInsightsCategory {
          edges {
            node {
              slug { current }
              title
              _id
            }
          }
        }
        allSanityBlogInsight {
          group(field: category___slug___current) {
            totalCount
            fieldValue
          }
        }
      }
    `}
    render={data => {
      const cats = data.allSanityInsightsCategory.edges
      const totals = data.allSanityBlogInsight.group

      return (
        <ul id="categories-list">
          <li>
            <Link to={`/blog/`}>
              All
            </Link>
          </li>
          {cats.map(({node: cat}) =>
            getTotal(cat.slug.current, totals) > 0 ? (
              <li key={cat._id}>
                <Link to={`/blog/${cat.slug.current}/`}>
                  {cat.title} ({getTotal(cat.slug.current, totals)})
                </Link>
              </li>
            ) : null
          )}
        </ul>
      )
    }}
  />
)

export default InsightFilters
